import { AggregateBy, SearchType } from '@/enums/Global';
import {
  BookApiOptions,
  ClientApiResponseResults,
  HeatmapSliderOptions,
} from './types';
import { cloneDeep } from 'lodash';
import { ClientHeatmapDataItem } from '@/types/Client';

type ClientDataState = {
  clientData: Array<ClientApiResponseResults>;
  totalResultCount: number;
  isLoading: boolean;
};

type HeatMapState = {
  heatmapSliderOptions: HeatmapSliderOptions;
  heatmapData: Array<ClientHeatmapDataItem>;
  isLoading: boolean;
};

export type State = {
  client: ClientDataState;
  heatmap: HeatMapState;
  settings: BookApiOptions;
};

export const defaultHeatmapSliderOptions: HeatmapSliderOptions = {
  xMinValue: 0,
  xMaxValue: 0,
  yMinValue: 0,
  yMaxValue: 0,
  hasHadFirstUpdate: false,
};

export const defaultSettings: BookApiOptions = {
  pageCount: 0,
  pageSize: 10,
  pageStart: 0,
  pageNo: 1,
  sortKey: 'aum',
  sortDesc: true,
  searchType: SearchType.FAMILY,
  searchTerm: '',
  filters: [],
  aggregateBy: AggregateBy.FAMILY,
  exactIdSearch: false,
};

export const state: State = {
  client: {} as ClientDataState,
  heatmap: {
    heatmapSliderOptions: { ...defaultHeatmapSliderOptions },
    heatmapData: [] as Array<ClientHeatmapDataItem>,
    isLoading: false,
  },
  settings: cloneDeep(defaultSettings),
};
